const tarievenMobileNav = document.querySelectorAll('.tarieven-mobile-title-nav');

tarievenMobileNav.forEach(nav => {
    nav.addEventListener("click", event => {
        nav.nextElementSibling.classList.toggle("active");
        nav.classList.toggle("active");
    });
});

const tarievenMobileNavLinks = document.querySelectorAll('.tarieven__list li a');
const tarievenMobileNavSingle = document.querySelector('.tarieven-mobile-title-nav');

tarievenMobileNavLinks.forEach(link => {
   link.addEventListener('click', (event) => {
       tarievenMobileNavSingle.nextElementSibling.classList.remove("active");
       tarievenMobileNavSingle.classList.remove("active");

       const navBody = document.querySelector('.tarieven__list');

       if(!navBody.classList.contains("active")) {
           navbody.classList.remove("active");
       } else {

       }
   });
});